<template>
  <v-snackbar
    v-model="show"
    :multi-line="message && message.length > 80"
    color="red darken-2"
    :timeout="7000"
  >
    {{ message }}
  </v-snackbar>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    show: false,
  }),

  computed: {
    ...mapGetters({
      message: "error/message",
    }),
  },

  watch: {
    message() {
      this.show = true;
    },
  },
};
</script>
